import { useMemo }      from 'react';
import deleteVideo      from './deleteVideo';
import { colors }       from 'utils/colors';
import { words }        from 'utils/dictionary';
import { makeStyles }   from 'makeStyles';
import { objType }      from 'types';

//const videoUrl = 'https://yisumatica-screen-recordings.s3.us-east-2.amazonaws.com/'


const useStyles = makeStyles()((Theme) => ({    
    root: {
      position:        'fixed',
      top:             0,
      left:            0,
      width:           '100%',
      height:          '100%',
      backgroundColor: '#00000044',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      transition:      'opacity 0.3s'
    },
    modal: {
      width:           '100%',
      height:          '100%',
      maxWidth:        700,
      maxHeight:       300,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      flexFlow:        'column',
      backgroundColor: '#FFF',
      borderRadius:    '0.2em',
      overflow:        'hidden',
      boxShadow:       '3px 3px 3px rgba(0,0,0,0.05)'
    },
    title: {
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      flexFlow:        'column',
      height:          '100%',
      width:           '100%',
      flex:            1,
      fontSize:        19,
      fontWeight:      'bold',
      borderBottom:    '1px solid #DDD',
  },
  buttonContainer: {
    maxHeight:       60,
    minHeight:       60,
    width:           '100%',
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'space-evenly',
  },
  button: {
        width:           175,
        height:          40,
        fontSize:        20,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        backgroundColor: colors.primary,
        color:           '#FFF',
        fontWeight:      'bold',
        cursor:          'pointer',
        borderRadius:    '0.2em',
        boxShadow:       '2px 4px 9px rgba(0,0,0,0.1)',
        '&:hover': {
            opacity: 0.5
        }
  }
}))

type ModalProps = {
    lang:          string;
    variant:       string;
    selectedVideo: objType;
    showModal:     boolean;
    setShowModal:  (val: boolean) => void;
}

const Modal: React.FC<ModalProps> = ({ lang, variant, selectedVideo, showModal, setShowModal }) => {
  
  const { classes } = useStyles();

  const rootStyle = useMemo(() => {
      return{
        transform: `translate(0vw, ${ showModal ? 0 : 400 }vh)`,
        opacity:   showModal ? 1 : 0
      }
  },[showModal])

  return (
    <div 
      className = { classes.root }
      style     = { rootStyle }
    >
      <div className = { classes.modal }>
        <div className = { classes.title }>
            <div>
              { variant === 'copyLink' ? words['linkCopied'][lang] : words['confirmVideoDeletion'][lang] }
            </div>
            {
              variant === 'deleteVid' && <div style = {{ borderTop: '8px solid transparent'}}>{ selectedVideo.title }</div>
            }
        </div>
        <div className = { classes.buttonContainer }>
            <div 
              className = { classes.button }
              onClick   = { () => { setShowModal(false) }}
            >
              { words['return'][lang] }
            </div>
            {
              variant === 'deleteVid' &&
              <div 
                className = { classes.button }
                onClick   = { () => { deleteVideo(selectedVideo.video_id) }}
              >
                { words['delete'][lang] }
              </div>
            }
        </div>
      </div>
    </div>
  );
}



export default Modal







